import React from 'react';

const useArticleListDerivedData = ({
  articles,
  selectedStatuses,
  showFavoritesOnly,
  isFavoritePage,
  timePeriod,
  selectedSources,
  selectedSentiments,
  selectedTags,
  selectedCollections,
  selectedMediaTypes,
  selectedContentTypes,
  selectedTiers,
  selectedEntityType,
  searchQuery,
  activeBrandName
}) => {
  const filteredArticles = React.useMemo(() => {
    let result = articles;

    if (showFavoritesOnly || isFavoritePage) {
      result = result.filter(article => article.isFavorite);
    }

    const localStatuses = selectedStatuses.filter(s => ['with_image', 'without_image'].includes(s));

    if (localStatuses.length === 0) {
      return result;
    }

    return result.filter(article => {
      return localStatuses.some(status => {
        if (status === 'with_image') return article.image || article.imageUrl;
        if (status === 'without_image') return !article.image && !article.imageUrl;
        return false;
      });
    });
  }, [articles, selectedStatuses, showFavoritesOnly, isFavoritePage]);

  const availableTags = React.useMemo(() => {
    const tagMap = new Map();

    articles.forEach(article => {
      article.tags?.forEach(tag => {
        const currentTagId = typeof tag === 'object' ? tag?._id : tag;

        if (!currentTagId || tagMap.has(currentTagId)) {
          return;
        }

        tagMap.set(currentTagId, tag);
      });
    });

    return Array.from(tagMap.values());
  }, [articles]);

  const hasEmptyStateFilters = React.useMemo(() => (
    (timePeriod && timePeriod !== 'all') ||
    selectedSources.length > 0 ||
    selectedSentiments.length > 0 ||
    selectedTags.length > 0 ||
    selectedCollections.length > 0 ||
    selectedMediaTypes.length > 0 ||
    selectedContentTypes.length > 0 ||
    selectedTiers.length > 0 ||
    Boolean(selectedEntityType) ||
    selectedStatuses.length > 0 ||
    Boolean(searchQuery)
  ), [
    timePeriod,
    selectedSources,
    selectedSentiments,
    selectedTags,
    selectedCollections,
    selectedMediaTypes,
    selectedContentTypes,
    selectedTiers,
    selectedEntityType,
    selectedStatuses,
    searchQuery
  ]);

  const entityTypeOptions = React.useMemo(
    () => [
      { value: 'brand', label: activeBrandName || 'Minha Marca' },
      { value: 'competitor', label: 'Concorrentes' }
    ],
    [activeBrandName]
  );

  return {
    availableTags,
    entityTypeOptions,
    filteredArticles,
    hasEmptyStateFilters
  };
};

export default useArticleListDerivedData;
